import type { JSONContent } from "@tiptap/core"; // Assuming you use @tiptap/core

export const enum NoteType {
  EXPLAIN = "explain",
  SIMPLIFY = "simplify",
  ASK = "ask",
  BLANK = "blank",
  EXAMPLES = "examples",
}

// Event name for content updates from the internal editor
export const NOTE_CONTENT_UPDATE_EVENT = "nw-note-content-update";

// Base properties common to all note types
export type BaseNoteProps = {
  id: string;
  group: string;
  heading?: string;
  placeholder?: string; // Placeholder for the internal editor
  highlightContext: string;
  surroundingContext: string;
  initialContent?: JSONContent | string; // Content for the internal editor
  // Used when carrying out an async action initially to show loading state
  loading: boolean;
  error?: string;
};

export type BlankNoteProps = BaseNoteProps & {
  notetype: NoteType.BLANK;
};

export type SimplifyNoteProps = BaseNoteProps & {
  notetype: NoteType.SIMPLIFY;
};

export type ExplainNoteProps = BaseNoteProps & {
  notetype: NoteType.EXPLAIN;
};

export type ExamplesNoteProps = BaseNoteProps & {
  notetype: NoteType.EXAMPLES;
};

export type AskNoteProps = BaseNoteProps & {
  notetype: NoteType.ASK;
} & NoteOptions[NoteType.ASK];

export type NWNoteProps = BlankNoteProps | SimplifyNoteProps | ExplainNoteProps | ExamplesNoteProps | AskNoteProps;


/**
 * Options specific to certain note types (currently only ASK).
 */
export type NoteOptions = {
  [NoteType.BLANK]: object;
  [NoteType.EXPLAIN]: object;
  [NoteType.SIMPLIFY]: object;
  [NoteType.EXAMPLES]: object;
  [NoteType.ASK]: {
    query: string;
  };
};
